var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28491 9L8.09241 10.815L11.7149 7.185",
    stroke: "#959FA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06241 1.83749C8.57991 1.39499 9.42741 1.39499 9.95241 1.83749L11.1374 2.85749C11.3624 3.05249 11.7824 3.20999 12.0824 3.20999H13.3574C14.1524 3.20999 14.8049 3.86249 14.8049 4.65749V5.93249C14.8049 6.22499 14.9624 6.65249 15.1574 6.87749L16.1774 8.06249C16.6199 8.57999 16.6199 9.42749 16.1774 9.95249L15.1574 11.1375C14.9624 11.3625 14.8049 11.7825 14.8049 12.0825V13.3575C14.8049 14.1525 14.1524 14.805 13.3574 14.805H12.0824C11.7899 14.805 11.3624 14.9625 11.1374 15.1575L9.95241 16.1775C9.43491 16.62 8.58741 16.62 8.06241 16.1775L6.87741 15.1575C6.65241 14.9625 6.23241 14.805 5.93241 14.805H4.63491C3.83991 14.805 3.18741 14.1525 3.18741 13.3575V12.075C3.18741 11.7825 3.02991 11.3625 2.84241 11.1375L1.82991 9.94499C1.39491 9.42749 1.39491 8.58749 1.82991 8.06999L2.84241 6.87749C3.02991 6.65249 3.18741 6.23249 3.18741 5.93999V4.64999C3.18741 3.85499 3.83991 3.20249 4.63491 3.20249H5.93241C6.22491 3.20249 6.65241 3.04499 6.87741 2.84999L8.06241 1.83749Z",
    stroke: "#959FA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.e4e5baa09321fea9e89032f5d6270205.svg";
export { ForwardRef as ReactComponent };